// src/components/shared/FilterSelect.jsx
import React from 'react';

const FilterSelect = ({ value, onChange, options, className }) => {
  // options: Array von { value, label } oder Array von Strings (dann wird label = value)
  const normalizedOptions = options.map((option) =>
    typeof option === "string" ? { value: option, label: option } : option
  );

  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={className}>
      {normalizedOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default FilterSelect;